import React from "react"
import { CreditCard } from "lucide-react"
import type { ClientUnpaidOrdersResponse } from "../../types"

interface AccountSummaryProps {
    unpaidOrders: ClientUnpaidOrdersResponse | null;
}

export const AccountSummary: React.FC<AccountSummaryProps> = ({ unpaidOrders }) => {
    if (!unpaidOrders || unpaidOrders.total_amount_owed <= 0) return null;

    return (
        <div className="bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-100/50 dark:border-gray-700/50">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-6 flex items-center gap-2">
                <CreditCard className="w-6 h-6 text-green-500" />
                Resumen de Cuenta
            </h2>

            <div className="space-y-4">
                {unpaidOrders.orders.flatMap((order) =>
                    order.order_products.map((item, index) => (
                        <div
                            key={`${order.uuid}-${index}`}
                            className="flex justify-between items-center py-3 border-b border-gray-100/50 dark:border-gray-700/50 last:border-b-0"
                        >
                            <span className="text-gray-700 dark:text-gray-300 font-medium">
                                {item.quantity}x {item.product_details?.name || item.offer_details?.name || "Producto"}
                            </span>
                            <span className="font-bold text-gray-900 dark:text-white">
                                ${((item.product_details?.price || item.offer_details?.price || 0) * item.quantity).toFixed(2)}
                            </span>
                        </div>
                    )),
                )}

                <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-2xl p-6 mt-6 backdrop-blur-sm border border-green-200/50 dark:border-green-800/50">
                    <div className="flex justify-between items-center">
                        <span className="text-xl font-bold text-gray-900 dark:text-white">Total a Pagar</span>
                        <span className="text-2xl font-bold text-green-600 dark:text-green-400">
                            ${unpaidOrders.total_amount_owed.toFixed(2)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
